module.exports = new __parcel__URL__("the-simpsons-hit-run.522a125f.jpg").toString();